import { makeStyles } from "@material-ui/core";
import { tesaBlue } from "../../../styles/colors";

const useStyles = makeStyles({
  hiddenButton: {
    backgroundColor: "transparent",
  },
  link: {
    color: tesaBlue,
    textDecoration: "none",
  },
  table: {
    "& .LEAPActionCell": {
      color: tesaBlue,
    },
    "& .LEAPLink": {
      with: "100%",
      paddingRight: "0.5rem",
    },
    "& .MuiTableCell-root": {
      lineHeight: "1.5rem",
    },
    "& .MuiTableRow-root": {
      "& .MuiTableCell-root:first-child": { position: "relative" },
    },
  },
});

export default useStyles;
